import { typesDetailInterface } from "../interface/TypeListInterface";

export const typesDetailInit : typesDetailInterface = {
    codeEntriesId : 0,
    codeEntriesName : "",
    codeTypeId : 0,
    deleteFlag : "",
    remark : "",
    crmCodeId : "",
}